import { API } from '~apis/axios/instance';

export const requestEmailPassCode = ({
  userId,
  email,
  partnerDomain,
}: {
  userId: string;
  email: string;
  partnerDomain?: string;
}) => {
  return API.post(`/api/v3/users/${userId}/email/passcode`, {
    data: { email, partnerDomain },
  });
};

interface ChangeEmailCheckRequest {
  userId: string;
  email: string;
  passcode: string;
}

export const changeEmail = ({ userId, email, passcode }: ChangeEmailCheckRequest) => {
  return API.patch(`/api/v3/users/${userId}/email`, { data: { email, passcode } });
};

export const verifyEmailChange = ({ email, passcode, userId }: ChangeEmailCheckRequest) => {
  return API.post(`/api/v3/users/${userId}/email/passcode/verify`, {
    data: { email, passcode },
  });
};
